export const USER_MESSAGES_ADD = 'USER_MESSAGES_ADD';
export const USER_MESSAGES_REMOVE_INDEX = 'USER_MESSAGES_REMOVE_INDEX';
export const USER_MESSAGES_REMOVE_ALL = 'USER_MESSAGES_REMOVE_ALL';

export function addUserMessage(data) {
  return {
    type: USER_MESSAGES_ADD,
    data,
  };
}

export function removeUserMessageByIndex(data) {
  return {
    type: USER_MESSAGES_REMOVE_INDEX,
    data,
  };
}

export function removeAllUserMessages() {
  return {
    type: USER_MESSAGES_REMOVE_ALL,
  };
}
